import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import ModalWindow from '../utils/modal'
import SimpleTable from '../utils/table'
import { Button } from 'react-bootstrap'

const HistoryRecordsListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.ARCHIVE)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const actions = {
    c: store.__('create'),
    u: store.__('update'),
    d: store.__('delete')
  }

  // preparing data into table
  let table = ''
  const rows = []
  const dataLength = store.cv && store.cv.data && store.cv.data.length
  const loading = <span>
    <span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />&nbsp;
    {store.__('Loading...')}
  </span>

  const returnTable = obj => {
    const tab = []
    Object.keys(obj).map(k => {
      tab.push(<tr key={k}>
        {!Array.isArray(obj) && <td>{k}</td>}
        <td>{obj[k] === undefined || obj[k] === null
          ? (obj[k] === null ? <em className='text-muted'>null</em> : '')
          : (typeof obj[k] === 'object'
            ? (Array.isArray(obj[k]) ? obj[k] : [obj[k]]).map(v => returnTable(v))
            : obj[k].toString())}</td>
      </tr>)
    })
    return tab.length > 0
      ? <table>{tab}</table>
      : <em className='text-muted'>[&nbsp;]</em>
  }

  if (store.cv.detail) {
    // console.log(JSON.stringify(store.cv.detail, null, 2))
    let latestKey = ''
    Array.isArray(store.cv.detail)
      ? store.cv.detail.map(val => {
        const vals = []
        Object.entries(val).map(([k, v]) => {
          let t
          let setClass1
          let setClass2 = 'text-half-opacity'

          if (Array.isArray(v)) {
            const newKey = v[0].toString() + '__' + (v[1] ? v[1].toString() : '')
            if (!latestKey || latestKey !== newKey) {
              latestKey = newKey
              setClass2 = ''
            }
          }
          if (k === 'type') {
            switch (v) {
            case 'del':
              setClass1 = 'text-danger'
              t = store.__('delete')
              break
            case 'put':
              setClass1 = 'text-success'
              t = store.__('put')
              break
            default:
              setClass1 = 'text-primary'
              t = v
              break
            }
          }
          if (v === undefined) {
            t = ''
          } else if (v === null) {
            t = <em className='text-muted'>null</em>
          } else if (Array.isArray(v) && v.length <= 1) {
            t = <table><tr><td>{(v[0] || v).toString()}</td></tr></table>
          } else if (Array.isArray(v)) {
            const td = v.map((i, j) => {
              return <td key={j} className={j <= 1 ? setClass2 : ''}>{i}</td>
            })
            t = <table><tr>{td}</tr></table>
          } else if (typeof v === 'object') {
            t = typeof v === 'object' ? returnTable(v) : JSON.stringify(v, null, 2)
          } else {
            t = v.toString()
          }
          vals.push(<td><span className={setClass1}>{t}</span></td>)
        })
        rows.push(<tr>{vals}</tr>)
      })
      : Object.keys(store.cv.detail).map(k => {
        rows.push(<tr key={k}>
          <td>{k}</td>
          <td>{store.cv.detail[k] === undefined || store.cv.detail[k] === null
            ? (store.cv.detail[k] === null ? <em className='text-muted'>null</em> : '')
            : (typeof store.cv.detail[k] === 'object'
              ? returnTable(store.cv.detail[k])
              : store.cv.detail[k].toString()
            )
          }</td>
        </tr>)
      })
    table = store.cv.detail
      ? <table className='archive-detail'>
        <tr>{Array.isArray(store.cv.detail)
          ? store.cv.detail[0] && store.cv.detail[0] !== null &&
          Object.keys(store.cv.detail[0]).map(k => <th key={k}>{k.toLocaleLowerCase()}</th>)
          : [<th key={1}>key</th>, <th key={2}>value</th>]}
        </tr>
        {rows}
      </table>
      : <p><br />{store.__('- EMPTY -')}</p>
  }

  return (
    <div className='card'>
      <Helmet title={store.__(linkConst.LINK_ARCHIVE_TITLE)} />
      {store.cv.title}
      <p style={{ paddingTop: '0.5em' }}>
        <button type='button' className={store.cv.onClick ? 'btn btn-default' : 'btn btn-info'}
          onClick={store.cv.onClick ||
            (() => store.router.goTo(store.views.entity_list, { entityname: linkConst.LINK_ARCHIVE }, store, {}))}>
          <span className={store.cv.onClick ? 'glyphicon glyphicon-remove' : 'glyphicon glyphicon-chevron-left'} />&nbsp;
          {store.cv.onClick ? defaultConst.TITLE_CANCEL : store.__('Return to list')}
        </button>
        {store.cv.detailLoad && <span>&nbsp;&nbsp;{loading}</span>}
      </p>
      {store.cv.data
        ? (<SimpleTable
          data={store.cv.data && store.cv.data.reverse()}
          labels={store.cv.headertitles}
          renderers={[
            (row) => (<div>
              <Button bsSize='small' onClick={() => (store.cv.detailLoad = true) && store.cv.showDetail(row)}>
                <i className='glyphicon glyphicon-eye-open'/>&nbsp; {store.__(defaultConst.TITLE_DETAIL)}
              </Button>
              {!store.onClick && store.cv.canRestore(row) &&
                <Button bsSize='small' onClick={() => store.cv.restore(row)}>
                  {store.__(defaultConst.TITLE_RESTORE)}
                </Button>
              }
            </div>
            ),
            (row) => <span>
              {moment(row.created).utc().format(defaultConst.DATE_FORMAT_FULL)}
            </span>,
            (row) => <span className={row.action === 'u'
              ? 'text-success'
              : (row.action === 'd' ? 'text-danger' : 'text-primary')}>
              {actions[row.action]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>,
            (row) => <span>{row.user.replace('.json', '')}</span>
          ]} />
        )
        : <p><br />{loading}</p>
      }
      {store.cv.detail &&
        <ModalWindow text={table}
          title={'history record detail'}
          button={store.__(defaultConst.TITLE_CANCEL)}
          hide={() => store.cv.hideDetail()}
          header={store.cv.dataInfo && store.cv.dataInfo.value}
          newer={dataLength > 1 && store.cv.dataInfo && (store.cv.dataInfo.key + 1 < dataLength)
            ? () => store.cv.showDetail(store.cv.data[store.cv.dataInfo.key + 1])
            : null}
          older={dataLength > 1 && store.cv.dataInfo && (store.cv.dataInfo.key - 1 >= 0)
            ? () => store.cv.showDetail(store.cv.data[store.cv.dataInfo.key - 1])
            : null}
        />
      }
    </div>
  )
}

HistoryRecordsListView.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(HistoryRecordsListView))
